export const namespace = 'ICHIJYOYA'
